import { render, staticRenderFns } from "./DropzoneFile.vue?vue&type=template&id=2f7f42d6&scoped=true&"
import script from "./DropzoneFile.vue?vue&type=script&lang=js&"
export * from "./DropzoneFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7f42d6",
  null
  
)

export default component.exports